import fetch from "isomorphic-unfetch"

const getAnimationData = ({ module, iconName }) =>
  fetch(`/private/shared/${module}/${iconName}.json`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((response) => response.json())
    .then((value) => value || {})
    .catch(() =>
      console.error(`Could not get animation json file for module ${module}`)
    )

export default getAnimationData
